const ru = {
    '/': {
        title: '{brand} и Ставки на Спорт | Мгновенный Вывод Криптовалюты',
        description: '{brand} и ставки на спорт в одном кошельке. Слоты, live-казино и спортивные ставки с мгновенным выводом крипты.',
        keywords: 'крипто казино, биткоин казино, ставки на спорт криптовалютой, крипто слоты, мгновенный вывод, provably fair казино'
    },
    '/casino': {
        title: 'Онлайн Казино | Слоты, Блэкджек & Живые Дилеры | {brand}',
        description: 'Слоты, блэкджек, рулетка & живые дилеры в {brand}. Сотни игр, быстрые крипто-депозиты & мгновенные выплаты 24/7.',
        keywords: 'крипто казино, биткоин казино, онлайн казино, крипто слоты, live казино, блэкджек, рулетка'
    },
    '/sports': {
        title: 'Онлайн Ставки на Спорт | Крипто Ставки & Коэффициенты | {brand}',
        description: 'Ставки на спорт в {brand}. Конкурентные коэффициенты на футбол, баскетбол & другие виды. Live-ставки, безопасные крипто-ставки & быстрые выплаты.',
        keywords: 'ставки на спорт криптовалютой, биткоин букмекер, live ставки, коэффициенты на футбол, ставки на киберспорт'
    },
    '/livecasino': {
        title: 'Живое Казино | Блэкджек, Рулетка & Живые Дилеры | {brand}',
        description: 'Блэкджек, рулетка & игры живого казино в {brand}. Настоящие дилеры, HD-трансляция & широкий выбор живых столов 24/7.',
        keywords: 'live казино, живые дилеры, live блэкджек, live рулетка, live баккара, шоу игры'
    },
    '/slots': {
        title: 'Онлайн Слоты | Большой Выбор Казино-Слотов | {brand}',
        description: 'Огромная коллекция слотов в {brand}. Классические фруктовые машины, видеослоты & прогрессивные джекпоты - всё доступно с крипто.',
        keywords: 'крипто слоты, биткоин слоты, онлайн слоты, видеослоты, слоты megaways, покупка бонуса'
    },
    '/vip': {
        title: 'VIP Программа | Эксклюзивные Награды & Преимущества | {brand}',
        description: 'VIP программа {brand}: эксклюзивные награды, персонализированные бонусы и приоритетная поддержка. Привилегии для лояльных игроков.',
        keywords: 'vip программа казино, рейкбек, бонусы за лояльность, казино для хайроллеров, vip уровни'
    },
    '/welcome-offer': {
        title: 'Приветственный Бонус | Крипто Казино | {brand}',
        description: 'Откройте для себя приветственное предложение {brand}. Начните с крипто и пользуйтесь эксклюзивными бонусами для новых игроков.',
        keywords: 'приветственный бонус казино, крипто бонус казино, бонус за первый депозит, предложение новым игрокам'
    },
    '/referral': {
        title: 'Реферальная Программа | Получайте Вознаграждения | {brand}',
        description: 'Приглашайте друзей на {brand} и зарабатывайте награды, когда они присоединятся и выполнят условия. Поделитесь ссылкой и начните зарабатывать.',
        keywords: 'реферальная программа казино, бонус за приглашение друга, партнёрские награды'
    },
    '/promotion-page': {
        title: 'Акции | Бонусы & Специальные Предложения | {brand}',
        description: 'Все активные акции на {brand}. Бонусы, бесплатные вращения и специальные предложения для крипто-игроков.',
        keywords: 'акции казино, крипто бонусы казино, еженедельная гонка, турниры казино'
    },
    '/hotslots': {
        title: 'Горячие Слоты | Популярные Казино Слоты | {brand}',
        description: 'Играйте в самые популярные слоты на {brand}. Горячие слоты с возможностью игры на крипто.'
    },
    '/newgames': {
        title: 'Новые Игры | Новейшие Казино Игры | {brand}',
        description: 'Откройте для себя новейшие казино игры на {brand}. Новые слоты, живые игры и настольные игры появляются регулярно.'
    },
    '/populargames': {
        title: 'Популярные Игры | Топ Казино Игры | {brand}',
        description: 'Самые популярные казино игры на {brand}. От слотов до живых игр - всё доступно с крипто.'
    },
    '/gameshows': {
        title: 'Игровые Шоу | Казино с Живыми Шоу | {brand}',
        description: 'Наслаждайтесь живыми игровыми шоу на {brand}. Настоящие ведущие, уникальные игры и крупные выигрыши в реальном времени.'
    },
    '/table_games': {
        title: 'Настольные Игры | Блэкджек, Рулетка & Баккара | {brand}',
        description: 'Играйте в блэкджек, рулетку, баккару и другие настольные игры на {brand}. Всё доступно с крипто.'
    },
    '/hotlive': {
        title: 'Популярное Живое Казино | Горячие Живые Игры | {brand}',
        description: 'Самые популярные игры живого казино на {brand}. Играйте с реальными дилерами в реальном времени.'
    },
    '/featurebuyin': {
        title: 'Слоты с Покупкой Бонуса | Feature Buy-in | {brand}',
        description: 'Играйте в слоты с возможностью покупки бонусного раунда на {brand}. Попадайте прямо в бонусную игру без ожидания.'
    },
    '/originals': {
        title: 'Оригинальные Игры Казино | Эксклюзивные Тайтлы | {brand}',
        description: 'Играйте в эксклюзивные оригинальные игры на {brand}. Уникальные тайтлы, которых не найдёте больше нигде, разработанные внутри компании для непревзойдённого игрового опыта.'
    },
    '/providers': {
        title: 'Провайдеры Игр | Партнёрские Студии & ПО | {brand}',
        description: 'Изучите всех провайдеров игр на {brand}. Мы сотрудничаем с ведущими студиями, чтобы предложить вам разнообразную и качественную крипто-казино библиотеку.'
    },
    '/about-us': {
        title: 'О Нас | Узнайте Больше о {brand}',
        description: 'Узнайте о {brand} - ведущем крипто-казино & букмекерской конторе. Мы обеспечиваем безопасное, честное & захватывающее азартное развлечение с мгновенными крипто-выплатами.'
    },
    '/affiliate': {
        title: 'Партнёрская Программа | Зарабатывайте Крипто с {brand}',
        description: 'Станьте партнёром {brand} & зарабатывайте комиссионные, продвигая наше крипто-казино. Конкурентные ставки, отслеживание в реальном времени & поддержка партнёров.'
    },
    '/faq': {
        title: 'FAQ | Часто Задаваемые Вопросы | {brand}',
        description: 'Найдите ответы на распространённые вопросы о {brand}. Изучите наш FAQ по вопросам аккаунтов, платежей, бонусов & казино-игр.'
    },
    '/aml-policy': {
        title: 'Политика AML | Противодействие Отмыванию Денег в {brand}',
        description: 'Политика AML {brand} обеспечивает безопасную и надёжную среду. Ознакомьтесь с нашими мерами по предотвращению незаконной деятельности на платформе.'
    },
    '/bonus-terms': {
        title: 'Условия Бонусов | Акции {brand}',
        description: 'Ознакомьтесь с правилами бонусов & акций {brand}. Узнайте, как получить, использовать & вывести бонусные выигрыши с нашей платформы.'
    },
    '/complaints-and-arbitration': {
        title: 'Жалобы и Арбитраж | Поддержка Игроков в {brand}',
        description: 'Ознакомьтесь с процессом рассмотрения жалоб & разрешения споров в {brand}. Мы гарантируем справедливое отношение и оперативно решаем проблемы игроков.'
    },
    '/fairness': {
        title: 'Доказуемо Честные Игры | Гарантия Честности в {brand}',
        description: '{brand} использует технологию доказуемой честности, чтобы каждый результат игры был проверяемым, прозрачным & полностью случайным.'
    },
    '/kyc-policy': {
        title: 'Политика KYC | Верификация Пользователей в {brand}',
        description: 'Политика KYC {brand} описывает наш процесс верификации личности. Узнайте, как мы защищаем игроков и поддерживаем безопасную игровую среду.'
    },
    '/payment-policy': {
        title: 'Платёжная Политика | Крипто Депозиты & Выводы | {brand}',
        description: '{brand} принимает крипто-депозиты & выводы. Ознакомьтесь с платёжной политикой для получения информации о лимитах, принятых монетах & сроках обработки.'
    },
    '/privacy-policy': {
        title: 'Политика Конфиденциальности | Защита Данных в {brand}',
        description: 'Политика конфиденциальности {brand}. Узнайте, как мы собираем, используем & защищаем ваши личные данные на нашей крипто-казино платформе.'
    },
    '/responsible-gaming': {
        title: 'Ответственная Игра | Играйте Безопасно в {brand}',
        description: '{brand} придерживается принципов ответственной игры. Используйте инструменты & ресурсы для управления своими игровыми привычками и безопасной игры.'
    },
    '/terms-of-service': {
        title: 'Условия Использования | {brand}',
        description: 'Ознакомьтесь с условиями, регулирующими использование {brand}. Поймите свои права и обязанности как игрока.'
    },
    '/terms-sports': {
        title: 'Условия Спортивных Ставок | {brand}',
        description: 'Условия спортивных ставок {brand}. Правила размещения ставок, выплаты выигрышей & использования букмекерского раздела на нашей платформе.'
    },
    '/special-bets': {
        title: 'Специальные ставки | Криптобукмекер | {brand}',
        description: 'Делайте специальные ставки на {brand}. Рынки по спорту, киберспорту & разовым событиям, мгновенные криптопополнения и быстрые выплаты.'
    },
    '/transparency': {
        title: 'Прозрачность | Доказуемо честное криптоказино | {brand}',
        description: 'Посмотрите, как {brand} работает открыто. Проверка доказуемой честности игр, публикуемые коэффициенты возврата из живого каталога & выплаты on-chain.'
    },
    '/faq/about': {
        title: 'О {brand} | Часто задаваемые вопросы',
        description: 'О {brand}: лицензия, как устроено криптоказино & что делает платформу честной. Ответы на самые частые вопросы.'
    },
    '/faq/account': {
        title: 'Аккаунт | Часто задаваемые вопросы | {brand}',
        description: 'Управление аккаунтом на {brand}: регистрация, вход, верификация & настройки профиля. Ответы на частые вопросы об аккаунте.'
    },
    '/faq/bonuses': {
        title: 'Бонусы | Часто задаваемые вопросы | {brand}',
        description: 'Бонусы {brand}: приветственные предложения, промокоды, требования по отыгрышу & награды. Ответы на частые вопросы о бонусах.'
    },
    '/faq/deposits': {
        title: 'Пополнение | Часто задаваемые вопросы | {brand}',
        description: 'Как пополнить счёт криптовалютой на {brand}: поддерживаемые монеты, сети, минимумы & время подтверждения. Ответы на частые вопросы.'
    },
    '/faq/games-sports': {
        title: 'Игры & спорт | Часто задаваемые вопросы | {brand}',
        description: 'Игры казино & ставки на спорт на {brand}: провайдеры, доказуемая честность, коэффициенты & live-ставки. Ответы на частые вопросы.'
    },
    '/faq/responsible-gambling': {
        title: 'Ответственная игра | Часто задаваемые вопросы | {brand}',
        description: 'Ответственная игра на {brand}: лимиты пополнения, самоисключение, периоды охлаждения & инструменты поддержки для безопасной игры.'
    },
    '/faq/security': {
        title: 'Безопасность | Часто задаваемые вопросы | {brand}',
        description: 'Безопасность на {brand}: защита аккаунта, двухфакторная аутентификация, честность & конфиденциальность данных. Ответы на частые вопросы.'
    },
    '/faq/support-disputes': {
        title: 'Поддержка & споры | Часто задаваемые вопросы | {brand}',
        description: 'Как получить помощь на {brand}: живой чат, время ответа & порядок разрешения споров. Ответы на частые вопросы.'
    },
    '/faq/withdrawals': {
        title: 'Вывод средств | Часто задаваемые вопросы | {brand}',
        description: 'Как вывести криптовалюту с {brand}: сроки выплат, минимумы, комиссии & лимиты. Ответы на частые вопросы о выводе средств.'
    }
};
export default ru;
